import { useEffect, useState } from 'react';
import { useSetAtom } from 'jotai';
import { userFeaturesAtom } from 'atoms/permissions';
import { tierAtom } from 'atoms/tier';
import { tenantNameAtom } from 'atoms/tenantName';
import { branchInformationAtom } from 'atoms/branchInformation';
import { branchesAtom, selectedBranchAtom } from 'atoms/branch';
import apiService from 'api/apiService';

export function useInitializeUser(isAuthenticated: boolean) {
  const [loaded, setLoaded] = useState(false);
  const setFeatures = useSetAtom(userFeaturesAtom);
  const setTier = useSetAtom(tierAtom);
  const setTenantName = useSetAtom(tenantNameAtom);
  const setBranchInformation = useSetAtom(branchInformationAtom);
  const setBranches = useSetAtom(branchesAtom);
  const setSelectedBranch = useSetAtom(selectedBranchAtom);

  const fetchUserConfig = async () => {
    try {
      const [userConfig, branches] = await Promise.all([apiService.clientConfiguration.get(), apiService.branches.getBranches(true)]);

      setTier(userConfig.tierInformation);
      setBranchInformation(userConfig.branchInformation);
      setFeatures(userConfig.enabledAddOns ?? []);
      setTenantName(userConfig.tenantName);
      setBranches(branches);

      if (branches.length > 0) {
        setSelectedBranch(branches[0]);
      }
    } catch (err) {
      console.error('Failed to load user config:', err);
    } finally {
      setLoaded(true);
    }
  };

  useEffect(() => {
    if (!isAuthenticated) return;
    fetchUserConfig();
  }, [isAuthenticated, setFeatures]);

  return loaded;
}
